import axios from 'axios';
import { API_URL } from 'configs'

export const DOCUMENTS_CATEGORY_REQUEST = 'DOCUMENTS_CATEGORY_REQUEST'
export const DOCUMENTS_CATEGORY_SUCCESS = 'DOCUMENTS_CATEGORY_SUCCESS'
export const DOCUMENTS_CATEGORY_BY_ATTR_SUCCESS = 'DOCUMENTS_CATEGORY_BY_ATTR_SUCCESS'
export const DOCUMENTS_CATEGORY_VALIDATION_ERROR = 'DOCUMENTS_CATEGORY_VALIDATION_ERROR'
export const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const HIDE_DOCUMENTS_CATEGORY_FEILD_VALIDATION_ERROR = "HIDE_DOCUMENTS_CATEGORY_FEILD_VALIDATION_ERROR"
export const REDIRECT_TO_DOCUMENTS_CATEGORY_LIST = 'REDIRECT_TO_DOCUMENTS_CATEGORY_LIST'
export const DOCUMENTS_CATEGORY_PARENT_SUCCESS = 'DOCUMENTS_CATEGORY_PARENT_SUCCESS'
export const DOCUMENTS_CATEGORY_GET_SUCCESS = 'DOCUMENTS_CATEGORY_GET_SUCCESS'
export const DOCUMENTS_CATEGORY_DROPDOWN_LIST_SUCCESS = 'DOCUMENTS_CATEGORY_DROPDOWN_LIST_SUCCESS'
export const DOCUMENTS_CATEGORY_SERVER_SUCCESS = 'DOCUMENTS_CATEGORY_SERVER_SUCCESS'
const SHOW_LOADER = 'SHOW_LOADER';
const HIDE_LOADER = 'HIDE_LOADER';

const showCommonLoader = (label = '') => ({
  type: SHOW_LOADER,
  common_loder_label: label
})
const hideCommonLoader = () => ({
  type: HIDE_LOADER,
})

const documentsCategoryRequest = () => ({
  type: DOCUMENTS_CATEGORY_REQUEST,
})

export const documentsCategoryServerListSuccess = () => ({
  type: DOCUMENTS_CATEGORY_SERVER_SUCCESS,
})

const documentsCategoryListSuccess = documentsCategoryList => ({
  type: DOCUMENTS_CATEGORY_SUCCESS,
  documentsCategoryList: documentsCategoryList,
})

const documentsCategoryParentListSuccess = documentsCategoryParentsList => ({
  type: DOCUMENTS_CATEGORY_PARENT_SUCCESS,
  documentsCategoryParentsList: documentsCategoryParentsList,
})

const documentsCategoryFailure = notification => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: 'general_error'
})
const validationError = notification => ({
  type: DOCUMENTS_CATEGORY_VALIDATION_ERROR,
  validation_error: notification,
})
const tokenError = notification => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: 'token_expire'
})

const documentsCategoryAddUpadteSuccess = (message, action, dispatch) => {
  dispatch(documentsCategorySuccessNotification(message))
  dispatch(redirectToDocumentsCategoryList())
}

export const redirectToDocumentsCategoryList = () => ({
  type: REDIRECT_TO_DOCUMENTS_CATEGORY_LIST,
})

const getDocumentsCategorySuccess = (response, action) => ({
  type: DOCUMENTS_CATEGORY_GET_SUCCESS,
  record: response,
  actionType: action
})

const documentsCategorySuccessNotification = message => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: message,
  snackbar_notification_type: 'success'
})

export const hideDocumentsCategoryValidationError = (feild_key) => ({
  type: HIDE_DOCUMENTS_CATEGORY_FEILD_VALIDATION_ERROR,
  feild_key: feild_key
})

const documentsCategoryByAttrListSuccess = documentsCategoryByAttrList => ({
  type: DOCUMENTS_CATEGORY_BY_ATTR_SUCCESS,
  documentsCategoryByAttrList: documentsCategoryByAttrList,
})

/*
* Documents Category dropdown list fetch methods
*/
const documentsCategoryDropdownListSuccess = documentsCategoryDropdownList => ({
  type: DOCUMENTS_CATEGORY_DROPDOWN_LIST_SUCCESS,
  documentsCategoryDropdownList: documentsCategoryDropdownList,
})

export const documentsCategoryDropdownListFetch = (object_viewed_id = '') => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(documentsCategoryRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "documents_category/getAllForDropdown", {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      params: {object_viewed_id: object_viewed_id}
    })
    .then((response) => {
      dispatch(documentsCategoryDropdownListSuccess(response.data))
      dispatch(hideCommonLoader())
    }, (error) => {
      handleErrorResponse(error, dispatch)
      dispatch(hideCommonLoader())
    });

  }
}


export const documentsCategoryByAttrListFetch = (object_viewed_id = '', request_data = []) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(documentsCategoryRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "documents_category/getByAttributes", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      data: {
        request_data: request_data,
        object_viewed_id: object_viewed_id
      },
    })
      .then((response) => {
        dispatch(documentsCategoryByAttrListSuccess(response.data))
        dispatch(hideCommonLoader())
      }, (error) => {
        handleErrorResponse(error, dispatch)
        dispatch(hideCommonLoader())
      });
  }
}

export const documentsCategoryListFetch = (object_viewed_id = '') => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(documentsCategoryRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "documents_category/getAll", {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      params: {object_viewed_id: object_viewed_id}
    })
      .then((response) => {
        dispatch(documentsCategoryListSuccess(response.data))
        dispatch(hideCommonLoader())
      }, (error) => {
        handleErrorResponse(error, dispatch)
        dispatch(hideCommonLoader())
      });
  }
}

export const addDocumentsCategory = (data) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(documentsCategoryRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "documents_category/create", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      data: data,
    })
      .then((response) => {
        documentsCategoryAddUpadteSuccess('Ticket Category Added Successfully', 'create', dispatch)
        dispatch(hideCommonLoader())
      }, (error) => {
        handleErrorResponse(error, dispatch)
        dispatch(hideCommonLoader())
      });

  }
}

export const updateDocumentsCategory = (data) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(documentsCategoryRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "documents_category/update/" + data.id, {
      method: "PUT",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer  ' + token
      },
      data: data
    })
      .then((response) => {
        documentsCategoryAddUpadteSuccess('Ticket Category Updated Successfully', 'update', dispatch)
        dispatch(hideCommonLoader())
      }, (error) => {
        handleErrorResponse(error, dispatch)
        dispatch(hideCommonLoader())
      });

  }
}

export const getDocumentsCategoryById = (id, action) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(documentsCategoryRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "documents_category/getById/" + id, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer  ' + token
      },
    })
      .then((response) => {
        dispatch(getDocumentsCategorySuccess(response.data, action))
        dispatch(hideCommonLoader())
      }, (error) => {
        handleErrorResponse(error, dispatch)
        dispatch(hideCommonLoader())
      });

  }
}

export const deleteDocumentsCategory = (documentsCategoryId, object_viewed_id) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(documentsCategoryRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "documents_category/delete/" + documentsCategoryId, {
      method: "DELETE",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      data: {
        object_viewed_id
      }
    })
      .then((response) => {
        dispatch(documentsCategorySuccessNotification('Ticket category deleted successfully'))
        dispatch(hideCommonLoader())
      }, (error) => {
        handleErrorResponse(error, dispatch)
        dispatch(hideCommonLoader())
      });
  }

}

// handling error reponse   
const handleErrorResponse = (error, dispatch) => {
  try {
    if (error.response.status === 422 && error.response.data.error) {
      dispatch(validationError(error.response.data.error))
    }
    else if (error.response.status === 401 && error.response.data.error) {
      dispatch(tokenError(error.response.data.error.toString()))
    }
    else {
      let err = '';
      if (error.response.data.error) {
        err = error.response.data.error.toString()
      }
      else {
        err = error.response.status + ` ` + error.response.statusText
      }
      dispatch(documentsCategoryFailure(err))
    }
  }
  catch (e) {
    dispatch(documentsCategoryFailure('Unable to perform action.Something went wrong'))
  }
}   